import { hc } from "hono/client";

import { type ApiApp } from "@mono/types";

import { useAuthStore } from "@/stores/auth.store";

export const apiClient: ReturnType<typeof hc<ApiApp>> = hc<ApiApp>(
  new URL("/api", window.location.origin).toString(),
  {
    fetch: (input: RequestInfo | URL, init?: RequestInit) => {
      const token = useAuthStore.getState().token;
      const headers = new Headers(init?.headers);
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return fetch(input, { ...init, headers });
    },
  },
);
